/**
 * CategoryCardsGrid - Grid wrapper for category cards
 *
 * Features:
 * - Responsive grid: 2 cols mobile, 4 cols desktop
 * - Category URL resolution via useCategoryUrls hook
 * - Loading skeleton state
 * - Error boundary ready
 */

import { CategoryCardItem } from './CategoryCardItem'
import { CategoryCardsSkeleton } from './CategoryCardsSkeleton'
import { useCategoryCardsVariants } from '../../../Theme'
import { SectionTitle } from '../../../UiBlocks'
import { useCategoryUrls } from '../../hooks'
import { LABELS } from '../../lib'

import type { HomepageCategoryCard } from '../../types'

interface CategoryCardsGridProps {
  cards: HomepageCategoryCard[]
  isLoading?: boolean
}

export function CategoryCardsGrid({ cards, isLoading }: CategoryCardsGridProps) {
  const { categoryCardsGridVariants } = useCategoryCardsVariants()
  const { categoryUrlMap, isLoading: isLoadingUrls } = useCategoryUrls(cards)

  if (isLoading || isLoadingUrls) {
    return <CategoryCardsSkeleton />
  }

  if (cards.length === 0) return null

  return (
    <>
      <SectionTitle size="lg">{LABELS.CATEGORY_SECTION_TITLE}</SectionTitle>
      <div className={categoryCardsGridVariants()}>
        {cards.map((card) => (
          <CategoryCardItem
            key={card.id}
            card={card}
            resolvedUrl={categoryUrlMap.get(card.link_value)}
          />
        ))}
      </div>
    </>
  )
}
